import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useCourse from '@/composables/useCourse'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useIcons from '@/composables/useIcons'
  import { useRouter } from 'vue-router/composables'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseModuleStatusContainer',
  props: {
    courseGroupId: String,
  },
  setup(__props) {

const props = __props;

  

  const { translateString } = useI18n()
  const router = useRouter()
  const { arrowRight } = useIcons()
  const { nextCourseModule, nextLesson, nextModuleIndex, nextLessonIndex, progressPercentage, currentCourseId } =
    useCourse()
  const { convertToRoman } = useCommonMixin()

  const toLesson = () => {
    const lessonIndex = nextLessonIndex(props.courseGroupId)
    const courseModule = nextCourseModule(props.courseGroupId)

    if (courseModule && progressPercentage.value(currentCourseId.value, props.courseGroupId) === 100) {
      return router
        .push({
          name: 'CourseModule',
          params: { moduleId: courseModule.id },
        })
        .catch(() => {
          return
        })
    }

    if (lessonIndex === (courseModule?.lessons.length || 0)) {
      if (courseModule?.guidedQuiz) {
        return router.push({ name: 'GuidedQuiz', params: { moduleId: courseModule?.id || '' } }).catch(() => {
          return
        })
      }
      toNextCourseModule()
    } else if (lessonIndex === 0) {
      toNextCourseModule()
    } else {
      router
        .push({
          name: 'Lesson',
          params: {
            moduleId: nextModule.value!.id,
            lessonId: nextLesson(props.courseGroupId)?.id || '',
          },
        })
        .catch(() => {
          return
        })
    }
  }

  const nextModule = computed(() => nextCourseModule(props.courseGroupId))

  const toNextCourseModule = () => {
    router
      .push({
        name: 'CourseModule',
        params: { moduleId: nextModule.value!.id },
      })
      .catch(() => {
        return
      })
  }

  const nextModuleLessonText = computed(() => {
    const courseModule =
      translateString('courses.module') + ` ${convertToRoman(nextModuleIndex(props.courseGroupId) + 1)} `
    const lessonIndex = nextLessonIndex(props.courseGroupId)
    let nextLesson = ''
    if (lessonIndex > 0) nextLesson = ` - ${translateString('courses.lesson')} ${lessonIndex + 1}`
    return courseModule + nextLesson
  })

return { __sfc: true,props, translateString, router, arrowRight, nextCourseModule, nextLesson, nextModuleIndex, nextLessonIndex, progressPercentage, currentCourseId, convertToRoman, toLesson, nextModule, toNextCourseModule, nextModuleLessonText, computed, KetchUpButton, SVGRenderer, useCourse, useCommonMixin, useIcons, useRouter, useI18n }
}

})